var map = {
	"./anuba.logo": 1,
	"./anuba.logo.svg": 1,
	"./autera.claim.logo": 2,
	"./autera.claim.logo.svg": 2,
	"./goll-logo-2019": 5,
	"./goll-logo-2019.svg": 5,
	"./goll.logo": 3,
	"./goll.logo.svg": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;